import React, { useState } from "react";
import { useNavigateStore } from "@stepHooks/useNavigateStore";
import { useCustomBrandingAssetStore } from "@hooks/customBranding/useCustomBrandingAsset";
import { TermsOfServiceModal } from "@components/presession/TermsOfServiceModal";
import { StepId } from "@constants/navigation";
import { StepFlowGate } from "@stepComponents/Navigator/StepFlowGate";
import { useLogStep } from "@hooks/useLogStep";

// TODO [LOWA-30534] From https://tiny.amazon.com/jkibijre
export const PostSignInStep = () => {
    useLogStep(StepId.POST_SIGN_IN);

    const navigateToSignInStep = useNavigateStore(
        (store) => store.navigateToSignInStep
    );

    const hasTermsOfService = useCustomBrandingAssetStore(
        (store) => store.hasTermsOfService
    );
    const [termsOfServiceAccepted, setTermsOfServiceAccepted] = useState(false);

    // Terms of service modal
    if (hasTermsOfService && !termsOfServiceAccepted) {
        return (
            <TermsOfServiceModal
                onCancel={() => {
                    setTermsOfServiceAccepted(false);
                    navigateToSignInStep();
                }}
                onProceed={() => {
                    setTermsOfServiceAccepted(true);
                }}
            />
        );
    }

    return (
        <StepFlowGate
            isCompleted={true}
            completedStepId={StepId.POST_SIGN_IN}
        />
    );
};
